import './RegisterApp.less';
import React, {useState, useEffect, useContext} from 'react';
import __ from "../../i18n";
import routes from "../../routing/routes";
import AccountForm from "./account-form/AccountForm";
import BeforeLoginTemplate from "../../templates/before-login/BeforeLoginTemplate";
import {Link, useHistory} from "react-router-dom";
import AuthContext from "../../contexts/auth/AuthContext";
import HistoryContext from "../../contexts/history/HistoryContext";


export default function RegisterApp() {

    const history = useHistory();

    const authContext = useContext(AuthContext);

    const historyContext = useContext(HistoryContext);

    const login = (info) => {
        authContext.setInfo(info);

        if (historyContext.loginReferer !== null) {
            history.push(historyContext.loginReferer);
        } else {
            history.push(routes.home.getUrl());
        }
    };

    return <div className="register-app">
        <BeforeLoginTemplate>
            <div className="step-title">{__('Create your account')}</div>
            <div className="login-ask">
                <span>{__('Already have an account?')}</span>
                <Link className="text-link" to={routes.login.getUrl()}>{__('Login')}</Link>
            </div>
            <AccountForm
                onDone={(info) => login(info)}
            />
        </BeforeLoginTemplate>
    </div>;
}
